import React, { useEffect, useState } from 'react'
import firebase from '../Firebase'
import './LastSolutionsStyles.css'
import {textcontent} from '../texts.js'

function LastSolutions({activelan}) {
  const [solList, setSolList] = useState('')

  useEffect(() => {
    renderLastSolutions()
  }, [])

  //Append Zero
  const az = n => {
    return n < 10 ? "0"+n : ""+n 
  }

  const renderLastSolutions = () => {
    var list = [];
    firebase.firestore().collection('solutions').orderBy("time","desc").limit(10).get()
    .then(snap => {
      snap.forEach(doc => {
        var docdata = doc.data();
        var date = new Date(docdata.time.toDate())
        list.push(
          <div>
            <p className='sol-name'>{docdata.solution}</p> 
             - 
            <p className='sol-time'>{az(date.getDate())}.{az(date.getMonth()+1)}.{date.getFullYear()}, {az(date.getHours())}:{az(date.getMinutes())}</p>
          </div>
        )
      })
      setSolList(list)
    })
  }

  return (
    <div className='solutions-history'>
      
      <p className='last-sol-title'>{textcontent.solutionstitle[activelan]}</p>
      {solList}
    </div>
  )
}

export default LastSolutions
